import { Card } from "../ui/card";
import { scoreTone, CAT_LABELS } from "./scoreTone";

const GradeTile = ({ label, grade, score, testId }) => (
  <div className="rounded-xl border bg-white p-4 text-center" data-testid={testId}>
    <div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className="text-4xl font-bold mt-1">{grade || "—"}</div>
    {score != null && <div className="text-xs text-muted-foreground">{score}/100</div>}
  </div>
);

export const ScoreHeader = ({ audit }) => {
  const g = audit.grader || {};
  const s = audit.seo_aeo || {};
  const tone = scoreTone(g.overall);
  return (
    <Card className="p-6" data-testid="pa-score-header">
      <div className="grid grid-cols-1 lg:grid-cols-[auto_1fr] gap-8 items-center">
        <div className="grid grid-cols-2 sm:flex gap-4">
          <div className={`rounded-2xl px-6 py-4 text-center ${tone.chip}`} data-testid="pa-website-score">
            <div className="text-xs uppercase tracking-wider opacity-80">Website Score</div>
            <div className="text-6xl font-bold leading-none mt-1">{g.overall ?? "…"}</div>
            <div className="text-sm font-medium mt-1">{g.band || (audit.steps?.grade === "running" ? "Scanning…" : "")}</div>
          </div>
          <GradeTile label="SEO" grade={s.seo_grade} score={s.seo_score} testId="pa-seo-grade" />
          <GradeTile label="AEO" grade={s.aeo_grade} score={s.aeo_score} testId="pa-aeo-grade" />
          <GradeTile label="Design" grade={audit.design ? `${audit.design.design_score}/10` : null} testId="pa-design-grade" />
        </div>
        <div className="space-y-2" data-testid="pa-categories">
          {Object.entries(CAT_LABELS).filter(([k]) => k === "speed" || g.cats?.[k] != null).map(([k, label]) => {
            const v = g.cats?.[k];
            const t = scoreTone(v);
            return (
              <div key={k} className="flex items-center gap-3 text-sm">
                <span className="w-32 text-muted-foreground">{label}</span>
                <div className="flex-1 h-2 rounded-full bg-zinc-100 overflow-hidden">
                  <div className={`h-full ${t.bar} transition-all duration-700`} style={{ width: `${v ?? 0}%` }} />
                </div>
                <span className={`w-14 text-right font-semibold ${t.text}`}>{v ?? (k === "speed" ? "n/a" : "—")}</span>
              </div>
            );
          })}
          {g.partial && <p className="text-xs text-amber-700">Partial score: part of the scan didn&apos;t finish. Run it again for a full score.</p>}
        </div>
      </div>
    </Card>
  );
};
